import React, { createContext, useContext } from "react";
import {
  PepperHotIcon,
  DazzlerIcon,
  KineticStrikeIcon,
  SonicIcon,
  GrenadeIcon,
  TearGasIcon,
} from "../../../Reuse/Icon";
import { setFilter } from "../../../Service/service";

const ListContext = createContext({
  isList: null,
  setIsList: () => undefined,
});
export const useListContextContext = () => useContext(ListContext);
export const ListContextProvider = ({ children, value }) => (
  <ListContext.Provider value={value}>{children}</ListContext.Provider>
);

const setSortOption = (label, value) => ({ label, value });
export const sortOption = [
  // setSortOption("Campus ID", "Campus ID"),
  setSortOption("Campus Number", "Campus Number"),
  setSortOption("Drone Count High to Low", "Drone Count High to Low"),
  setSortOption("Drone Count Low to High", "Drone Count Low to High"),
];

const setDroneType = (label = "", value = "", type = "drone_type") => ({
  label,
  value,
  icon: value,
  type,
});

export const droneTypes = [
  setDroneType("Dazzler", "DAZZLER"),
  setDroneType("Kinetic Strike", "KINETIC_STRIKE"),
  setDroneType("Pepper Hot", "PEPPER_HOT"),
  setDroneType("Sonic", "SONIC"),
  setDroneType("Grenade", "GRENADE"),
  setDroneType("Tear Gas", "TEAR_GAS"),
];

const setDroneStatus = (label = "", value = "", type = "drone_status") => ({
  label,
  value,
  type,
});
export const droneStatus = [
  setDroneStatus("Ready to Go", "AVAILABLE"),
  setDroneStatus("Unavailable", "UNAVAILABLE"),
  setDroneStatus("In Flight", "IN_FLIGHT"),
  setDroneStatus("Updating FW", "FW_UPDATE_IN_PROGRESS"),
];
export const doorStatus = [
  setDroneStatus("Open", "OPEN", "status"),
  setDroneStatus("Close", "CLOSE", "status"),
];

export const defaultFilter = [
  setFilter("search", "", "search", false),
  setFilter("sort_by", "", "sort_by"),
  setFilter("drone_types", [], "drone_types", true, "array"),
  setFilter("operational_statuses", "", "operational_statuses"),
  setFilter("active_drones_from", "", "active_drones"),
  setFilter("active_drones_to", "", "active_drones"),
  setFilter("floor_number_from", "", "floor_number"),
  setFilter("floor_number_to", "", "floor_number"),
  setFilter("drone_box_capacity_from", "", "drone_box_capacity"),
  setFilter("drone_box_capacity_to", "", "drone_box_capacity"),
];

export const DroneIcon = React.memo((props) => {
  const { icon, sx = {} } = props;
  return (
    <React.Fragment>
      {icon === "DAZZLER" ? (
        <DazzlerIcon fontSize="small" sx={{ color: "#00FF66", ...sx }} />
      ) : null}
      {icon === "KINETIC_STRIKE" ? (
        <KineticStrikeIcon fontSize="small" sx={{ color: "#000000", ...sx }} />
      ) : null}
      {icon === "PEPPER_HOT" ? (
        <PepperHotIcon fontSize="small" sx={{ color: "#FF0000", ...sx }} />
      ) : null}
      {icon === "SONIC" ? (
        <SonicIcon fontSize="small" sx={{ color: "#2E90FA", ...sx }} />
      ) : null}
      {icon === "GRENADE" ? (
        <GrenadeIcon fontSize="small" sx={{ color: "#FFC60D", ...sx }} />
      ) : null}
      {icon === "TEAR_GAS" ? (
        <TearGasIcon fontSize="small" sx={{ color: "#2ED3B7", ...sx }} />
      ) : null}
    </React.Fragment>
  );
});
